import {
  ModalWrap,
  ModalBack,
  ModalCard,
  ModalBar,
  ModalBody,
  ModalList,
} from "./FeatureModal.styled";

export default function FeatureModal({ feature, onClose }) {
  if (!feature) return null;
  const Icon = feature.icon;
  return (
    <ModalWrap>
      <ModalBack onClick={onClose} />
      <ModalCard>
        <ModalBar>
          <span className="icon">
            <Icon size={24} />
          </span>
          <div style={{ fontWeight: 600, fontSize: "1.125rem" }}>
            {feature.title}
          </div>
          <button onClick={onClose}>Close</button>
        </ModalBar>
        <ModalBody>{feature.tagline}</ModalBody>
        <ModalList>
          {feature.bullets.map((b, i) => (
            <li key={i}>
              <span style={{ display: "none" }} />
              {b}
            </li>
          ))}
        </ModalList>
      </ModalCard>
    </ModalWrap>
  );
}
